var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"exercise-wrapper"},[_c('img',{staticClass:"logoImg",attrs:{"src":require("../../assets/images/logo.png"),"alt":""}}),_c('QuestionModal')],1)}
var staticRenderFns = []

export { render, staticRenderFns }